export default "__VITE_ASSET__BHpXq9n3__"